// extracted by mini-css-extract-plugin
export default {"container":"index_container__fVnNd","icon":"index_icon__5d408","text":"index_text__bkcCo"};